// Imports
import { useAppSelector } from '../../../../../../shareables/foundation/front-end/redux/hooks';


// Define the accepted props
interface Props {
	pageID: number;
}


// Function component
const PageTypesLink: React.FC<Props> = ({ pageID }) => {
	// Use Redux functionality
	const pages = useAppSelector((state) => state.self.pages);
	
	
	// Extract URL
	const pageData = pages?.find((page) => page.id === pageID)?.data;
	const pageDataURL = pageData && 'url' in pageData ? pageData.url : '';
	
	
	// Redirect to URL
	if (pageDataURL) {
		window.location.replace(pageDataURL);
	}
	
	
	// Render nothing
	return null;
};

export default PageTypesLink;
